import { Navigate } from "react-router-dom";
import { useSelectedCountry } from "@/context/SelectedCountryContext";

export default function Countries() {
  const { slug } = useSelectedCountry();

  // If a destination is locked-in, jump straight into that country's guide.
  if (slug) return <Navigate to={`/countries/${slug}`} replace />;

  // Otherwise the CountryGate (rendered globally in App) covers the screen
  // and forces a selection — this page is effectively just a placeholder.
  return (
    <div data-testid="countries-page" className="max-w-3xl mx-auto px-6 py-24 text-center text-[#475569]">
      Pick a destination from the welcome panel to see your country guide.
    </div>
  );
}
